import {
  BoxProps,
  CardProps,
  Grid,
  GridItem,
  TextProps,
} from "@chakra-ui/react";

import { ProfileCard } from "@picovico/ui";
import { getPageRoutes } from "routes/pageRoutes";
import { useAppSelector } from "store";
import { ProfileStatTabs } from "./ProfileTabs";

export interface UserProfileProps {
  profileCardProps?: BoxProps;
  profileCardTextProps: TextProps;
  profileNameProps: TextProps;
  profileContainerGridProps?: BoxProps;
  profileCardGridItemProps?: BoxProps;
  profileStatGridItemProps?: BoxProps;
  profileStatProps?: ProfileStatProps;
  // Forwarded to the redesigned ProfileCard for per-tenant theming.
  profileBannerProps?: BoxProps;
  avatarProps?: Record<string, unknown>;
  detailContainerProps?: BoxProps;
  detailRowProps?: BoxProps;
  detailLabelProps?: TextProps;
  detailValueProps?: TextProps;
  editButtonProps?: Record<string, unknown>;
}

export interface ProfileStatProps {
  profileStatTabsProps?: CardProps;
  movieCardDetailActionProps?: any;
  movieDetailDrawerLabelTextProps?: TextProps;
}

function UserProfile({
  profileCardProps,
  profileStatProps,
  profileCardTextProps,
  profileNameProps,
  profileCardGridItemProps,
  profileContainerGridProps,
  profileStatGridItemProps,
  profileBannerProps,
  avatarProps,
  detailContainerProps,
  detailRowProps,
  detailLabelProps,
  detailValueProps,
  editButtonProps,
}: UserProfileProps) {
  const { user } = useAppSelector((state) => state.user);

  return (
    <Grid
      templateColumns={{
        base: "1fr",
        md: "repeat(12,1fr)",
      }}
      gap="3rem"
      {...profileContainerGridProps}
    >
      <GridItem
        colSpan={{
          base: 1,
          md: 4,
          lg: 3,
        }}
        {...profileCardGridItemProps}
      >
        <ProfileCard
          basicInfo={{
            name: user.name,
            username: user.username,
            image: user.image,
          }}
          profileDetail={{
            email: user.email,
            "date of birth": user.date_of_birth,
            mobile: user.mobile,
          }}
          profileEditLink={getPageRoutes("profile_edit")}
          profileCardProps={profileCardProps}
          profileCardTextProps={profileCardTextProps}
          profileNameProps={profileNameProps}
          profileBannerProps={profileBannerProps}
          avatarProps={avatarProps}
          detailContainerProps={detailContainerProps}
          detailRowProps={detailRowProps}
          detailLabelProps={detailLabelProps}
          detailValueProps={detailValueProps}
          editButtonProps={editButtonProps}
        />
      </GridItem>
      <GridItem
        colSpan={{
          base: 1,
          md: 8,
          lg: 9,
        }}
        {...profileStatGridItemProps}
      >
        <ProfileStatTabs {...profileStatProps} />
      </GridItem>
    </Grid>
  );
}

export default UserProfile;
